import { atom } from "jotai";

const selectedStoreAtom = atom({
  id: null,
  name: null,
  distanceToStore: null,
  unformattedHours: null,
  specialHours: null,
  address: {
    address1: null,
    address2: null,
    city: null,
    state: null,
    postalCode: null,
    country: null,
  },
});

export default selectedStoreAtom;
